module.exports = __webpack_public_path__ + "static/media/icon.d7f88fea.png";